import API from "@utils/plugins/API";

const EquipmentService = {
  all: (params) => {
    return API.get("equipments", { params: params });
  },
  create: (name, name_eng, description, equipment_category_id) => {
    return API.post("equipments", {
      name,
      name_eng,
      description,
      equipment_category_id,
    });
  },
  update: (id, name, name_eng, description, equipment_category_id) => {
    return API.put(`equipments/${id}`, {
      name,
      name_eng,
      description,
      equipment_category_id,
    });
  },
  find: (id) => {
    return API.get(`equipments/${id}`);
  },
  destroy: (id) => {
    return API.delete(`equipments/${id}`);
  },
};

export default EquipmentService;
